export default "__VITE_ASSET__BMbTE8M7__"